<template>
  <bly-permission-field :label="label" :hint="hint" :error="error" :required="required">
    <input
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :min="min"
      :max="max"
      :step="step"
      class="h-8 max-h-8 min-h-6 w-full rounded-sm border bg-black/20 px-2.5 text-xs text-[#e5eefc] transition-[border-color,box-shadow] duration-150 outline-none disabled:bg-[#151b21] disabled:text-slate-400 read-only:bg-[#151b21] read-only:text-slate-400"
      :class="error ? 'border-[#ff8a65]' : 'border-[#2a333d] focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]'"
      @input="$emit('input', $event.target.value)"
    />
  </bly-permission-field>
</template>

<script>
export default {
  name: "NativeTextField",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
